export default{
    current_contact: {},
    list: {}
}